import { EMediaQuery, ETextColor } from 'src/styles/theme/utils/enums';
import {
	addFramesStyles,
	addHiddenRangesStyles,
	addMarginStyles,
	addPaddingStyles,
	addTextColumnStyles,
	addTransition,
	getTextColor,
	getThemeColor,
	mq,
	setFontSize
} from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';
import { EFontFamily } from './NGText.enum';
import { INGText } from './NGText.type';

const generateTextStyle = (p: any) => {
	return css`
		display: inline-block;

		-webkit-tap-highlight-color: transparent;

		${setFontSize(p)}
		${addTransition()}
		${addHiddenRangesStyles(p)}

		font-weight: 400;

		text-align: ${p.textAlign};
		font-style: ${p.fontStyle};

		${p.fontFamily
			? css`
					font-family: ${p.fontFamily};
					${p.fontFamily === EFontFamily.cinzel ? `font-weight: 700;` : ''}
			  `
			: ''}

		${p.singleLine ? 'line-height: 1rem; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;' : ''}
		${p.firstLetterFactor ? '& span {display: inline-flex; align-items: center;}' : ''}

		${p.whiteSpace ? `white-space: ${p.whiteSpace}` : ''};

		${p.inheritStyle
			? css`
					font-size: inherit;
					font-weight: inherit;
					font-family: inherit;
					letter-spacing: inherit;
					text-align: inherit;
					line-height: inherit;

					${mq(
						EMediaQuery.xl,
						`
					font-size: inherit;
					font-weight: inherit;
					letter-spacing: inherit;
					text-align: inherit;
					line-height: inherit;
					`
					)}

					${mq(
						EMediaQuery.lg,
						`
					font-size: inherit;
					font-weight: inherit;
					letter-spacing: inherit;
					text-align: inherit;
					line-height: inherit;
					`
					)}

					${mq(
						EMediaQuery.md,
						`
					font-size: inherit;
					font-weight: inherit;
					letter-spacing: inherit;
					text-align: inherit;
					line-height: inherit;
					`
					)}

					${mq(
						EMediaQuery.sm,
						`
					font-size: inherit;
					font-weight: inherit;
					letter-spacing: inherit;
					text-align: inherit;
					line-height: inherit;
					`
					)}
			  `
			: `
		`}

		${p.textColor === ETextColor.gradientGold
			? css`
					background-clip: text;
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
					background-image: linear-gradient(155.3deg, #9f8c6c 29.33%, #ffeecf 50.34%, #9f8c6c 70.95%);
			  `
			: `color: ${getTextColor(p)};`}

		${p.shadowColor ? `text-shadow: 0px 0px 12px ${getThemeColor(p.theme, p.shadowColor)};` : ''}

		${p.fontWeight ? `font-weight: ${p.fontWeight} !important;` : ''}
		${p.opacityReduced ? `opacity: 0.7;` : ''}
		${p.textTransform ? `text-transform: ${p.textTransform} !important;` : ''}
		${p.textDecoration ? `text-decoration: ${p.textDecoration} !important;` : ''}
		${p.isHidden ? `opacity: 0;` : ''}
	`;
};

export const StyledTextParagraph = styled.p<INGText>`
	${(p) => css`
		${generateTextStyle(p)}
		${addPaddingStyles(p)}
		${addMarginStyles(p)}
		${addFramesStyles(p)}
		${addTextColumnStyles(p)}
	`}
`;
export const StyledFirstLetter = styled.span<INGText>`
	${(p) => css`
		${generateTextStyle(p)}
		@-moz-document url-prefix() {
			color: inherit;
		}
		font-size: ${p.firstLetterFactor}em;
	`}
`;

export const StyledTextSpan = styled.span<INGText>`
	${(p) => css`
		${generateTextStyle(p)}
		${addPaddingStyles(p)}
		${addMarginStyles(p)}
		${addFramesStyles(p)}
	`}
`;
